var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.isEditing
          ? _vm.$t("contactModuleRules.ruleEditor.editTitle")
          : _vm.$t("contactModuleRules.ruleEditor.createTitle"),
        width: "900px",
        footer: null,
        bodyStyle: { padding: "24px" },
      },
      on: { cancel: _vm.onCancel },
    },
    [
      _c(
        "div",
        { staticClass: "rule-editor" },
        [
          _c(
            "a-steps",
            {
              staticClass: "steps-container",
              attrs: { current: _vm.currentStep, size: "small" },
            },
            [
              _c("a-step", {
                attrs: {
                  title: _vm.$t("contactModuleRules.ruleEditor.stepWhen"),
                },
              }),
              _vm._v(" "),
              _c("a-step", {
                attrs: {
                  title: _vm.$t("contactModuleRules.ruleEditor.stepConditions"),
                },
              }),
              _vm._v(" "),
              _c("a-step", {
                attrs: {
                  title: _vm.$t("contactModuleRules.ruleEditor.stepActions"),
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "step-content" }, [
            _vm.currentStep === 0
              ? _c("div", { staticClass: "when-step" }, [
                  _c("h3", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("contactModuleRules.ruleEditor.whenQuestion")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "rule-name-input" },
                    [
                      _c("label", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("contactModuleRules.ruleEditor.ruleName")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("a-input", {
                        attrs: {
                          placeholder: _vm.$t(
                            "contactModuleRules.ruleEditor.ruleNamePlaceholder"
                          ),
                          size: "large",
                        },
                        model: {
                          value: _vm.localRule.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.localRule, "name", $$v)
                          },
                          expression: "localRule.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "when-options" }, [
                    _c(
                      "div",
                      {
                        staticClass: "when-option",
                        class: {
                          selected: _vm.localRule.when === "contact_created",
                        },
                        on: {
                          click: function ($event) {
                            _vm.localRule.when = "contact_created"
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "option-icon" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("person_add"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "option-content" }, [
                          _c("h4", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "contactModuleRules.ruleEditor.contactCreatedTitle"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "contactModuleRules.ruleEditor.contactCreatedDesc"
                                )
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "option-check" }, [
                          _vm.localRule.when === "contact_created"
                            ? _c("i", { staticClass: "material-icons" }, [
                                _vm._v("check_circle"),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "when-option",
                        class: {
                          selected: _vm.localRule.when === "chat_opened",
                        },
                        on: {
                          click: function ($event) {
                            _vm.localRule.when = "chat_opened"
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "option-icon" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("chat"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "option-content" }, [
                          _c("h4", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "contactModuleRules.ruleEditor.chatOpenedTitle"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "contactModuleRules.ruleEditor.chatOpenedDesc"
                                )
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "option-check" }, [
                          _vm.localRule.when === "chat_opened"
                            ? _c("i", { staticClass: "material-icons" }, [
                                _vm._v("check_circle"),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentStep === 1
              ? _c(
                  "div",
                  { staticClass: "if-step" },
                  [
                    _c("h3", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "contactModuleRules.ruleEditor.conditionsQuestion"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("FilterBuilder", {
                      attrs: { "when-type": _vm.localRule.when },
                      model: {
                        value: _vm.localRule.conditions,
                        callback: function ($$v) {
                          _vm.$set(_vm.localRule, "conditions", $$v)
                        },
                        expression: "localRule.conditions",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.currentStep === 2
              ? _c(
                  "div",
                  { staticClass: "actions-step" },
                  [
                    _c("h3", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "contactModuleRules.ruleEditor.actionsQuestion"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("ActionsEditor", {
                      attrs: { "when-type": _vm.localRule.when },
                      model: {
                        value: _vm.localRule.actions,
                        callback: function ($$v) {
                          _vm.$set(_vm.localRule, "actions", $$v)
                        },
                        expression: "localRule.actions",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "step-navigation" },
            [
              _vm.currentStep > 0
                ? _c(
                    "a-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.currentStep--
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("contactModuleRules.ruleEditor.back")) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "spacer" }),
              _vm._v(" "),
              _c("a-button", { on: { click: _vm.onCancel } }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("contactModuleRules.ruleEditor.cancel")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _vm.currentStep < 2
                ? _c(
                    "a-button",
                    {
                      attrs: { type: "primary", disabled: !_vm.canProceed },
                      on: {
                        click: function ($event) {
                          _vm.currentStep++
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("contactModuleRules.ruleEditor.next")) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.currentStep === 2
                ? _c(
                    "a-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSave } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("contactModuleRules.ruleEditor.save")) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }